import { NgModule } from '@angular/core';
import { MeddataThemeModule } from './modules';
import { UiComponent } from './ui.component';



@NgModule({
  declarations: [
    UiComponent
  ],
  imports: [
    MeddataThemeModule
  ],
  exports: [
    UiComponent
  ]
})
export class UiModule { }
